import { render } from "./TitleBoxWidget.vue?vue&type=template&id=6182a2b9&scoped=true"
import script from "./TitleBoxWidget.vue?vue&type=script&lang=js"
export * from "./TitleBoxWidget.vue?vue&type=script&lang=js"

import "./TitleBoxWidget.vue?vue&type=style&index=0&id=6182a2b9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6182a2b9"],['__file',"src/containers/widget/components/TitleBoxWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6182a2b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6182a2b9', __exports__)) {
    api.reload('6182a2b9', __exports__)
  }
  
  module.hot.accept("./TitleBoxWidget.vue?vue&type=template&id=6182a2b9&scoped=true", () => {
    api.rerender('6182a2b9', render)
  })

}


export default __exports__